import React, { useState } from "react";
import Mapir from "mapir-react-component";
import Header from "../../header";

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc5Y2QyNDY1MjIzNzM0YzRmZjE2ZjA0YWM2MWJmOTJiOTY2NGYwZTkyNTNmZjg2MTQzZmFhMjBlMjBmOTBkY2UyZTczODIxNGM3OTZlZmI5In0.eyJhdWQiOiIxNjczMCIsImp0aSI6Ijc5Y2QyNDY1MjIzNzM0YzRmZjE2ZjA0YWM2MWJmOTJiOTY2NGYwZTkyNTNmZjg2MTQzZmFhMjBlMjBmOTBkY2UyZTczODIxNGM3OTZlZmI5IiwiaWF0IjoxNjQyNTEwNTUwLCJuYmYiOjE2NDI1MTA1NTAsImV4cCI6MTY0NTAxNjE1MCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.CEPerZBI7ShzHAmrhmvevZaY5WNyHu6BZuNlM3gXtwhC66vnGuRtgUmwlILUaT6gG5TfphY_Z31PV0fZXOY661n5yUuiZL6pkdfc_2LSamgm9GpnrjO_8_rfRU0pLYgAzpaGkVLioBBfvofdpBrAzKtLFEFFeX2CFJvbeMWiZrepxZTVREA8T_SOyp8eG-J_I1Q_-T4QW4enA8tlnzEO1nyAdMXjztIGcHSxCblDJYIwh34Kz5bNLEJRaBMMYwCHFwjKE6v3bc9KglnFpvDnhlUyv211i8ZhA6HcxaJl0c-DrkZA_8m6QY_84E0L3R0NsATJnL76NNRXmA9kswzRtA",
        "Mapir-SDK": "reactjs",
      },
    };
  },
});

const App = (props) => {
  const [markerArray, setMarkerArray] = useState([]);
  const [coord, setCoord] = useState([46.299999, 38.066666]);
  function reverseFunction(map, e) {
    var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc5Y2QyNDY1MjIzNzM0YzRmZjE2ZjA0YWM2MWJmOTJiOTY2NGYwZTkyNTNmZjg2MTQzZmFhMjBlMjBmOTBkY2UyZTczODIxNGM3OTZlZmI5In0.eyJhdWQiOiIxNjczMCIsImp0aSI6Ijc5Y2QyNDY1MjIzNzM0YzRmZjE2ZjA0YWM2MWJmOTJiOTY2NGYwZTkyNTNmZjg2MTQzZmFhMjBlMjBmOTBkY2UyZTczODIxNGM3OTZlZmI5IiwiaWF0IjoxNjQyNTEwNTUwLCJuYmYiOjE2NDI1MTA1NTAsImV4cCI6MTY0NTAxNjE1MCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.CEPerZBI7ShzHAmrhmvevZaY5WNyHu6BZuNlM3gXtwhC66vnGuRtgUmwlILUaT6gG5TfphY_Z31PV0fZXOY661n5yUuiZL6pkdfc_2LSamgm9GpnrjO_8_rfRU0pLYgAzpaGkVLioBBfvofdpBrAzKtLFEFFeX2CFJvbeMWiZrepxZTVREA8T_SOyp8eG-J_I1Q_-T4QW4enA8tlnzEO1nyAdMXjztIGcHSxCblDJYIwh34Kz5bNLEJRaBMMYwCHFwjKE6v3bc9KglnFpvDnhlUyv211i8ZhA6HcxaJl0c-DrkZA_8m6QY_84E0L3R0NsATJnL76NNRXmA9kswzRtA",
      },
    });
    localStorage.setItem("lat", e.lngLat.lat);
    localStorage.setItem("lng", e.lngLat.lng);
    if (props.changeMap) {
      props.changeMap(e.lngLat);
    }
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[e.lngLat.lng, e.lngLat.lat]}
        anchor="bottom"
      />,
    );
    setMarkerArray(array);
  }
  return (
    <div className="myMap">
      <Header
        showSearchBar={true}
        title={"انتخاب موقعیت مکانی"}
        backHandler={props.handleShowmap}
      />
      <div className="App">
        {props.location !== undefined ? (
          <Mapir
            center={[
              props.location.mapDetails?.lng,
              props.location.mapDetails?.lat,
            ]}
            coordinates={[
              props.location.mapDetails.lng,
              props.location.mapDetails.lat,
            ]}
            minZoom={[13]}
            scrollZoom={false}
            hash={true}
            Map={Map}
            interactive={true}
          >
            <Mapir.Layer type="symbol" layout={{ "icon-image": "harbor-15" }} />
            <Mapir.Marker
              coordinates={[
                props.location.mapDetails.lng,
                props.location.mapDetails.lat,
              ]}
              center={[
                props.location.mapDetails.lng,
                props.location.mapDetails.lat,
              ]}
              anchor="bottom"
            />
          </Mapir>
        ) : (
          <Mapir
            center={
              localStorage.getItem("lat") && localStorage.getItem("lng")
                ? [localStorage.getItem("lng"), localStorage.getItem("lat")]
                : coord
            }
            Map={Map}
            onClick={reverseFunction}
          >
            {markerArray}
            <Mapir.Marker
              coordinates={[
                localStorage.getItem("lng"),
                localStorage.getItem("lat"),
              ]}
              center={
                localStorage.getItem("lat") && localStorage.getItem("lng")
                  ? [localStorage.getItem("lng"), localStorage.getItem("lat")]
                  : coord
              }
              anchor="bottom"
            />
          </Mapir>
        )}
      </div>
      <button
        className="btn btn--addmap"
        onClick={() => {
          props.handleShowmap(false);
        }}
      >
        تایید
      </button>
    </div>
  );
};

export default App;
